import { PluginKey, TextSelection, Plugin, Selection, NodeSelection } from 'prosemirror-state';
import { keydownHandler } from 'prosemirror-keymap';
import { GapCursorExtension } from '../../../citadel/extensions/gap-cursor-extension/index.js';
import 'prosemirror-model';
import 'prosemirror-inputrules';
import 'prosemirror-commands';
import { GapCursor, gapCursorSituation, closedAfter, closedBefore } from '../../../citadel/kit/GapcursorSelection/index.js';
export { GapCursor, gapCursorSituation } from '../../../citadel/kit/GapcursorSelection/index.js';

// 获取浏览器和系统信息
function getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var pluginKey$1 = new PluginKey("gap_cursor_pc");
// 指定pos的节点是否显示
var nodeIsDisplay = function(view, pos) {
    var node = view.domAtPos(pos).node;
    for(var dom = node; dom && dom !== view.dom; dom = dom.parentElement){
        if (dom.nodeType === 1 && window.getComputedStyle(dom).display === "none") {
            return false;
        }
    }
    return true;
};
var isInlineGapcursor = function(selection) {
    return _instanceof(selection, GapCursor) && (selection.gapCursorType === gapCursorSituation.afterInlineNode || selection.gapCursorType === gapCursorSituation.beforeInlineNode);
};
var checkClosedAfter = function(dir, $pos, selection) {
    if (closedAfter($pos, true)) {
        var type = GapCursor.getType($pos, 1);
        var gapcursor = new GapCursor($pos, type);
        if (!gapcursor.eq(selection)) {
            return type;
        }
        if (dir > 0 && selection.gapCursorType !== gapcursor.gapCursorType && !(isInlineGapcursor(gapcursor) && isInlineGapcursor(selection))) {
            return type;
        }
    }
    return null;
};
var checkClosedBefore = function(dir, $pos, selection) {
    if (closedBefore($pos, true)) {
        var type = GapCursor.getType($pos, -1);
        var gapcursor = new GapCursor($pos, type);
        if (!gapcursor.eq(selection)) {
            return type;
        }
        if (dir < 0 && selection.gapCursorType !== gapcursor.gapCursorType && !(isInlineGapcursor(gapcursor) && isInlineGapcursor(selection))) {
            return type;
        }
    }
    return null;
};
var _map_find;
var gapcursorEnableCheck = function(dir, $pos, selection, firstCheckAfter) {
    return (_map_find = (firstCheckAfter ? [
        checkClosedAfter,
        checkClosedBefore
    ] : [
        checkClosedBefore,
        checkClosedAfter
    ]).map(function(_) {
        return _(dir, $pos, selection);
    }).find(function(_) {
        return _;
    })) !== null && _map_find !== void 0 ? _map_find : null;
};
var moveFactory = function(state, dispatch, view, $side, dir) {
    return function(origin) {
        var gapcursorBias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, firstGapcursorCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var selection = state.selection, doc = state.doc;
        var whoHasNodeViews = new Set();
        view.someProp("nodeViews", function(_) {
            var nodeViewKeys = Object.keys(_);
            nodeViewKeys.forEach(function(__) {
                return whoHasNodeViews.add(__);
            });
            return false;
        });
        if ($side) {
            var moveTo = $side.pos + origin;
            var nextSel = Selection.near(state.doc.resolve(moveTo), dir);
            // 由于Selection.near会移动到已经设置为display: node的元素中（例如没有标题的样式宏）,所以需要继续寻找知道找到不是display: node的元素
            while(!nodeIsDisplay(view, nextSel.$from.pos)){
                var from = nextSel.from;
                nextSel = Selection.near(state.doc.resolve(from + origin), dir);
                if (nextSel.from === from) break;
            }
            if (nextSel) {
                var _loop = function() {
                    if (i < 0 || i >= doc.nodeSize - 1) return "break";
                    var $i = doc.resolve(i);
                    var gapcursorCheck = function() {
                        var situation = gapcursorEnableCheck(dir, $i, selection, dir * gapcursorBias > 0);
                        if (situation) {
                            return new GapCursor($i, situation);
                        }
                        return null;
                    };
                    var nodeSelectionCheck = function() {
                        var node = dir > 0 ? $i.nodeAfter : $i.nodeBefore;
                        if (node) {
                            var nodePos = dir > 0 ? $i.pos : $i.pos - node.nodeSize;
                            if (whoHasNodeViews.has(node.type.name) && node.type.spec.allowGapCursor && NodeSelection.isSelectable(node) && !NodeSelection.create(doc, nodePos).eq(selection)) {
                                return NodeSelection.create(doc, nodePos);
                            }
                        }
                        return null;
                    };
                    var gapcursorResult = gapcursorCheck();
                    var nodeSelectionResult = nodeSelectionCheck();
                    if (firstGapcursorCheck) {
                        if (gapcursorResult) {
                            nextSel = gapcursorResult;
                            return "break";
                        }
                        if (nodeSelectionCheck()) {
                            nextSel = nodeSelectionResult;
                            return "break";
                        }
                    } else {
                        if (nodeSelectionCheck()) {
                            nextSel = nodeSelectionResult;
                            return "break";
                        }
                        if (gapcursorResult) {
                            nextSel = gapcursorResult;
                            return "break";
                        }
                    }
                    i += dir;
                };
                var i = moveTo;
                var end = dir > 0 ? nextSel.from : nextSel.to;
                while((end - i) * dir >= 0){
                    var _ret = _loop();
                    if (_ret === "break") break;
                }
            }
            return nextSel;
        }
        return null;
    };
};
function arrowForHorizontal(dir) {
    return function(state, dispatch, view) {
        var selection = state.selection, tr = state.tr;
        var $from = selection.$from, $to = selection.$to;
        var $side = dir > 0 ? $to : $from;
        var move = moveFactory(state, dispatch, view, $side, dir);
        /**
     *  大思路，光标只能在下列光标之间切换（除表格选区）
     *  TextSeletion ⇌----⇌  Gapcursor  ⇌----⇌ NodeSelection
     *  Gapcursor ⇌----⇌ Gapcursor (在两个块级宏上下切换)
     */ /**
     * TextSelection只能变换成Gapcuor,当能变换成Gapcursor则优先变到Gapcursor，否则不做处理
     */ if (_instanceof(selection, TextSelection)) {
            var oneStepSelection = move(dir, -1);
            if (_instanceof(oneStepSelection, GapCursor)) {
                dispatch(tr.setSelection(oneStepSelection).scrollIntoView());
                return true;
            }
        }
        /**
     * Gapcusor可以变换成任意类型Selection
     * 优先计算在光标不变换的情况下是否可以转换成NodeSelection，如果可以表示用户在往这个Gapcursor所相邻的Node方向移动，需要设置成NodeSelection
     * 如果原地不动无法转换成NodeSelection，但可以转换成Gapcursor，表示用户在上下相邻的块级元素间移动，所以需要移动到Gapcursor
     * 最后都没有命中则直接移动到Prosemirror计算后的位置
     */ if (_instanceof(selection, GapCursor)) {
            var zeroStepSelection = move(0);
            if (_instanceof(zeroStepSelection, NodeSelection) && zeroStepSelection.node.type.name !== "table" || _instanceof(zeroStepSelection, GapCursor)) {
                dispatch(tr.setSelection(zeroStepSelection).scrollIntoView());
            } else {
                dispatch(tr.setSelection(move(dir)).scrollIntoView());
            }
            return true;
        }
        /**
     * NodeSelection只可以变换成Gapcursor
     * 如果在原地不动的情况下找到了Gapcursor则直接使用，否则就交给prosemirror处理
     */ if (_instanceof(selection, NodeSelection)) {
            var zeroStepSelection1 = move(0, -1);
            if (_instanceof(zeroStepSelection1, GapCursor)) {
                view.dispatch(tr.setSelection(zeroStepSelection1).scrollIntoView());
                return true;
            }
        }
        return false;
    };
}
var arrowForVertical = function() {
    return function(state, dispatch) {
        if (_instanceof(state.selection, GapCursor)) {
            var selection = state.selection;
            var doc = state.doc, tr = state.tr;
            dispatch(tr.setSelection(TextSelection.create(doc, selection.from)).scrollIntoView());
        }
        return false;
    };
};
var handlePCKeyDown = keydownHandler({
    ArrowLeft: arrowForHorizontal(-1),
    ArrowRight: arrowForHorizontal(1),
    ArrowUp: arrowForVertical(),
    ArrowDown: arrowForVertical()
});
var handleBeforeInput = function(view) {
    var selection = view.state.selection;
    if (!getSystemInfo().isMobile && _instanceof(selection, GapCursor)) {
        var _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
        if (selection.gapCursorType === gapCursorSituation.afterNode || selection.gapCursorType === gapCursorSituation.beforeNode) {
            tr.insert(tr.selection.from, schema.nodes.paragraph.create(null));
            var newSelection = TextSelection.create(tr.doc, tr.selection.from - 1);
            view.dispatch(tr.setSelection(newSelection));
        }
    }
    return true;
};
var GapCursorPCExtension = /*#__PURE__*/ function(GapCursorExtension) {
    _inherits(GapCursorPCExtension, GapCursorExtension);
    var _super = _createSuper(GapCursorPCExtension);
    function GapCursorPCExtension() {
        _classCallCheck(this, GapCursorPCExtension);
        return _super.apply(this, arguments);
    }
    var _proto = GapCursorPCExtension.prototype;
    _proto.plugin = function plugin(params) {
        var pcPlugin = new Plugin({
            key: pluginKey$1,
            props: {
                handleKeyDown: getSystemInfo().isMobile ? function() {
                    return false;
                } : handlePCKeyDown,
                handleDOMEvents: {
                    beforeinput: handleBeforeInput
                }
            }
        });
        return [
            _get(_getPrototypeOf(GapCursorPCExtension.prototype), "plugin", this).call(this, params),
            pcPlugin
        ];
    };
    return GapCursorPCExtension;
}(GapCursorExtension);

export { GapCursorPCExtension, handlePCKeyDown };
//# sourceMappingURL=index.js.map
